export const formatUserLocation = (geofenceData) => {
  if (!geofenceData) {
    return '—';
  }
  if (geofenceData.zoneName) {
    return geofenceData.zoneName;
  }
  if (geofenceData.address) {
    return geofenceData.address;
  }
  if (geofenceData.insideGeofence === false) {
    return 'Outside zone';
  }
  return '—';
};

export const formatDeviceLocation = (deviceSnapshot) => {
  if (!deviceSnapshot) {
    return '—';
  }
  if (deviceSnapshot.available === false) {
    return 'No recent ping';
  }
  if (deviceSnapshot.address) {
    return deviceSnapshot.address;
  }
  if (deviceSnapshot.latitude && deviceSnapshot.longitude) {
    return `${deviceSnapshot.latitude}, ${deviceSnapshot.longitude}`;
  }
  return '—';
};
